import React from 'react';
import './ShopStatusBanner.css';
import { FiClock, FiCheckCircle, FiXCircle } from 'react-icons/fi';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { SkeletonTheme } from 'react-loading-skeleton';


const ShopStatusBanner = ({ status, loading }) => {
  // Helper to convert "18:00" to "6:00 PM"
  const formatTime = (time24) => {
    if (!time24 || typeof time24 !== 'string') return '';
    const [hour, minute] = time24.split(':');
    const h = parseInt(hour, 10);
    const ampm = h >= 12 ? 'PM' : 'AM';
    const formattedHour = h % 12 || 12; // Convert 0 to 12 for 12 AM, and 12 to 12 for 12 PM
    return `${formattedHour}:${minute} ${ampm}`;
  };
if (loading) {
        return (
            <SkeletonTheme baseColor="#fdeadc" highlightColor="#fef5ee">
                <div className="shop-status-banner loading">
                    <div className="status-icon">
                        <Skeleton circle width={24} height={24} />
                    </div>
                    <div className="status-text">
                        <p>
                            <strong><Skeleton width={150} /></strong>
                        </p>
                        <p className="hours" style={{ display: 'flex', alignItems: 'center' }}>
                            <FiClock size={14} style={{ marginRight: '5px', opacity: 0.5 }}/>
                            <Skeleton width={250} />
                        </p>
                    </div>
                </div>
            </SkeletonTheme>
        );
    }
  return (
    <div className={`shop-status-banner ${status.isShopCurrentlyOpen ? 'open' : 'closed'}`}>
      <div className="status-icon">
        {status.isShopCurrentlyOpen ? <FiCheckCircle /> : <FiXCircle />}
      </div>
      <div className="status-text">
        <p>
          {status.isShopCurrentlyOpen ? <strong>Open for Orders</strong> : <strong>Currently Closed</strong>}
        </p>
        <p className="hours">
          <FiClock size={14}/> 
          Open today from {formatTime(status.shopOpenTime)} to {formatTime(status.shopCloseTime)} IST
        </p>
      </div>
    </div>
  );
};

export default ShopStatusBanner;